import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import cookiesHelper from "../../helpers/cookies";

import { resetSession } from "../../store/slices/global";
import api from "../apiClient";

const useSignOut = () => {
    const dispatch = useDispatch();

    const mutationFn = async () => {
        const token = cookiesHelper.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.post(`users/sign-out`);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSettled: () => {
            cookiesHelper.removeCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
            dispatch(resetSession());
            window.location.href = "/auth/sign-in";
        },
    });
};

export default useSignOut;